"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdFormik = require("cccisd-formik");
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _ImagePicker = _interopRequireDefault(require("../../ImagePicker"));
var _helpers = require("../../helpers");
var _navigations = _interopRequireDefault(require("../../../navigations"));
var _SurveySelector = _interopRequireDefault(require("../SurveySelector"));
var _style = _interopRequireDefault(require("./style.css"));
var _externalRegistrationDcw = _interopRequireDefault(require("./externalRegistrationDcw.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialValues = {
  toggle: false,
  tabName: 'Course Registration',
  isInternalRegistration: false,
  navigation: 'noSidebar',
  options: [],
  isExternalRegistration: false,
  externalRegistrationDeploymentId: ''
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.registration.toggle) {
    if (!values.registration.tabName) {
      localErrors['registration.tabName'] = 'Course Registration Tab Name is required';
    }
    if (!values.registration.isInternalRegistration && !values.registration.isExternalRegistration) {
      var msg = 'To use Course Registration, you must select either an internal survey or external deployment.';
      localErrors['registration.isInternalRegistration'] = msg;
      localErrors['registration.isExternalRegistration'] = msg;
    }
    if (values.registration.isInternalRegistration && values.registration.options.length === 0) {
      localErrors['registration.options'] = 'You must select at least one Course Registration survey';
    }
    if (values.registration.isExternalRegistration && !values.registration.externalRegistrationDeploymentId) {
      localErrors['registration.externalRegistrationDeploymentId'] = 'You must select a deployment';
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = exports.formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'course',
  key: 'registration'
};

/* Main Component */
var FormRegistration = function FormRegistration(_ref) {
  var assignmentData = _ref.assignmentData,
    formProps = _ref.formProps;
  var _formProps$values$reg = formProps.values.registration,
    externalRegistrationDeploymentId = _formProps$values$reg.externalRegistrationDeploymentId,
    isExternalRegistration = _formProps$values$reg.isExternalRegistration,
    isInternalRegistration = _formProps$values$reg.isInternalRegistration,
    toggle = _formProps$values$reg.toggle;
  var questSettings = assignmentData.settings,
    currentSurveylistList = assignmentData.currentSurveylistList,
    assignmentId = assignmentData.assignmentId,
    projectId = assignmentData.groupId;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    externalRegistrationOptions = _useState4[0],
    setExternalRegistrationOptions = _useState4[1];
  (0, _react.useEffect)(function () {
    function getDeployments() {
      return _getDeployments.apply(this, arguments);
    }
    function _getDeployments() {
      _getDeployments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, deploymentList;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _externalRegistrationDcw["default"],
                variables: {
                  projectId: projectId,
                  assignmentId: assignmentId
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              response = _context.v;
              deploymentList = (0, _get2["default"])(response, 'data.flows.deploymentList', []) || [];
              if (!deploymentList.some(function (d) {
                return d.value === '';
              })) {
                deploymentList.unshift(deploymentList.length === 0 ? {
                  value: '',
                  label: '-- No Deployments Available --'
                } : {
                  value: '',
                  label: '-- Choose deployment --'
                });
              }
              setExternalRegistrationOptions(deploymentList);
              setIsLoading(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getDeployments.apply(this, arguments);
    }
    getDeployments();
  }, []);
  var renderMainToggle = function renderMainToggle() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.toggle",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Course Registration Tab",
        tooltip: 'Forces users to complete the selected ' + 'Registration Survey(s) before they can access the course.'
      })
    });
  };
  var renderTabNameField = function renderTabNameField() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.tabName",
      component: _cccisdFormik.CccisdInput,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Course Registration Tab Name",
        tooltip: "The text for Course Registration in the tab bar. When active, Replaces Course Tab Name."
      })
    });
  };
  var renderInternalRegistrationToggle = function renderInternalRegistrationToggle() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.isInternalRegistration",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Course-Specific Registration Survey",
        tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h6", null, "A Course-Specific registration survey is unique to this course."), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "It must be survey(s) within this Quest."), /*#__PURE__*/_react["default"].createElement("li", null, "Forces users to complete the selected survey(s) before they can access the course."), /*#__PURE__*/_react["default"].createElement("li", null, "If using both an course-specific registration survey and a shared registration survey, the shared registration survey will play first.")))
      })
    });
  };
  var renderInternalRegistrationFields = function renderInternalRegistrationFields() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].fieldSection
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.options",
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Course-Specific Registration Survey(s)",
        tooltip: "Select the survey(s) to include in the Course Registration."
      }),
      component: _SurveySelector["default"],
      surveyList: currentSurveylistList.surveyList
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-info",
      style: {
        paddingBottom: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.navigation",
      label: "Navigation for Course-Specific Registration",
      component: _ImagePicker["default"],
      options: _navigations["default"].filter(function (nav) {
        return !nav.handle.match(/^courseWrapper/);
      }),
      questSettings: questSettings,
      height: "98px",
      settingsFieldName: "registration.navigationSettings"
    })));
  };
  var renderExternalRegistrationToggle = function renderExternalRegistrationToggle() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.isExternalRegistration",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Shared Course Registration Survey",
        tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h6", null, "A shared registration survey can be shared across multiple courses."), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Forces users to complete it just once in general instead of once per course."), /*#__PURE__*/_react["default"].createElement("li", null, "If the user completed the deployment in a different course, it will not show again."), /*#__PURE__*/_react["default"].createElement("li", null, "It must be created as a separate Quest and separate Deployment."), /*#__PURE__*/_react["default"].createElement("li", null, "If using both a shared registration survey and a course-specific registration survey, the shared registration survey will play first.")))
      })
    });
  };
  var renderExternalRegistrationFields = function renderExternalRegistrationFields() {
    var selectedDcw = externalRegistrationOptions.find(function (dcw) {
      return Number(dcw.value) === Number(externalRegistrationDeploymentId);
    });
    var warning;
    var selectedType = (0, _get2["default"])(selectedDcw, 'type', 'group');
    var selectedNav = (0, _get2["default"])(selectedDcw, 'assignment.settings.navigation', '');
    if (selectedType !== 'group') {
      var typeMapper = {
        anon: 'Anonymous',
        known: 'Known'
      };
      warning = "This deployment is set up for ".concat(typeMapper[selectedType], " respondents. ") + 'You likely meant to choose a deployment that has Managed respondents.';
    } else if (selectedNav === 'courseWrapper') {
      warning = 'This deployment uses a course wrapper. You should change the selected ' + 'Quest to use a different navigation style.';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].fieldSection
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].externalRegistrationWidth
    }, isLoading ? /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true,
      type: "inline"
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "registration.externalRegistrationDeploymentId",
      component: _cccisdFormik.CccisdSelect,
      label: "Shared Course Registration Deployment",
      options: externalRegistrationOptions
    })), warning && /*#__PURE__*/_react["default"].createElement("p", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null), "\xA0\xA0", warning), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].divider
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, "Course Registration"), renderMainToggle(), toggle && renderTabNameField(), toggle && renderExternalRegistrationToggle(), toggle && isExternalRegistration && renderExternalRegistrationFields(), toggle && renderInternalRegistrationToggle(), toggle && isInternalRegistration && renderInternalRegistrationFields());
};
var _default = exports["default"] = FormRegistration;